import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getFilterOptions = (data: PropertyType): Promise<PropertyType> =>
	api.post(`user/filters`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data.filtersData);
	});
